import React from 'react';
import { MODALS } from '../../../../config/images';
const ModalAlertWarning = ({ 
  showModalAlertWarning,
  closeModal,
  error,
  accept = closeModal,
  color="#CA2D00",
  showAcceptButton = true,
  loading = false
}) => {
  if (!showModalAlertWarning) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
      <div className="w-[90%] sm:w-auto sm:min-w-[420px] sm:max-w-[520px] bg-white rounded-3xl shadow-lg flex flex-col pb-4">
        <div className='flex justify-end'>
          <button
            onClick={closeModal}
            className="px-4 py-2 rounded-md"
            disabled={loading}
          >
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>
        </div>
        <div className='flex flex-col items-center justify-center gap-3 p-4 px-8'>
            <svg width="53" height="46" viewBox="0 0 53 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.671492 37.7549L21.8455 2.40593C22.2914 1.67144 22.9189 1.06421 23.6677 0.642793C24.4165 0.22138 25.2613 0 26.1205 0C26.9797 0 27.8245 0.22138 28.5733 0.642793C29.322 1.06421 29.9496 1.67144 30.3955 2.40593L51.5695 37.7549C52.0058 38.511 52.2365 39.3682 52.2388 40.2411C52.2411 41.114 52.0149 41.9724 51.5826 42.7308C51.1503 43.4892 50.527 44.1212 49.7747 44.564C49.0225 45.0068 48.1674 45.245 47.2945 45.2549H4.94649C4.07325 45.2459 3.21761 45.0083 2.46481 44.5657C1.712 44.1231 1.0883 43.4909 0.655851 42.7322C0.223398 41.9735 -0.00271954 41.1148 2.46838e-05 40.2415C0.0027689 39.3682 0.234278 38.5109 0.671492 37.7549ZM26.1205 13.7549C26.9161 13.7549 27.6792 14.071 28.2418 14.6336C28.8044 15.1962 29.1205 15.9593 29.1205 16.7549V25.7549C29.1205 26.5506 28.8044 27.3136 28.2418 27.8763C27.6792 28.4389 26.9161 28.7549 26.1205 28.7549C25.3248 28.7549 24.5618 28.4389 23.9992 27.8763C23.4366 27.3136 23.1205 26.5506 23.1205 25.7549V16.7549C23.1205 15.9593 23.4366 15.1962 23.9992 14.6336C24.5618 14.071 25.3248 13.7549 26.1205 13.7549ZM23.1205 34.7549C23.1205 33.9593 23.4366 33.1962 23.9992 32.6336C24.5618 32.071 25.3248 31.7549 26.1205 31.7549H26.1445C26.9401 31.7549 27.7032 32.071 28.2658 32.6336C28.8284 33.1962 29.1445 33.9593 29.1445 34.7549C29.1445 35.5506 28.8284 36.3137 28.2658 36.8763C27.7032 37.4389 26.9401 37.7549 26.1445 37.7549H26.1205C25.3248 37.7549 24.5618 37.4389 23.9992 36.8763C23.4366 36.3137 23.1205 35.5506 23.1205 34.7549Z"
             fill={`${color}`}/>
            </svg>

            <div className='flex flex-col gap-4'>
              <p className="text-sm text-center font-itcdemi">
                {error}
              </p>
              {showAcceptButton && accept && (
                <button
                onClick={accept}
                disabled={loading}
                className={`text-sm underline font-itcbold text-blue ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}>
                  Aceptar
                </button>
              )}

            </div>
        </div>
      </div>
    </div>
  );
};
export default ModalAlertWarning;
